import { alpha, Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { Iconify } from "..";

export const LandingFactoid = ({
  isDark,
  text,
  helpText,
  value,
  valueVariant = "h5",
  tooltipText,
  valueNowrap,
  height = "100%",
}: {
  isDark?: boolean;
  valueNowrap?: boolean;
  value: string;
  text?: string;
  tooltipText?: string;
  helpText?: string;
  valueVariant?: "h3" | "h5";
  height?: string;
}) => {
  const theme = useTheme();
  return (
    <Box
      component={Stack}
      spacing={1.5}
      sx={{
        p: 3,
        backgroundColor: isDark ? theme.palette.grey[900] : alpha(theme.palette.info.main, 0.08),
        borderRadius: 1.5,
        height,
      }}
    >
      <Stack direction={"row"}>
        {text && <Typography variant="subtitle2">{text || " "}</Typography>}
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <Iconify icon={"material-symbols:info-outline"} />
          </Tooltip>
        )}
      </Stack>
      {value && (
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Typography whiteSpace={valueNowrap ? "nowrap" : "initial"} variant={valueVariant}>
            {value}
          </Typography>
          {helpText && <Typography variant="bodySm">{helpText}</Typography>}
        </Stack>
      )}
    </Box>
  );
};
